import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="dialog"
export default class extends Controller<HTMLDialogElement> {
  static values = {
    autoOpen: { type: Boolean, default: true },
    removeOnClose: { type: Boolean, default: true },
  };

  declare readonly autoOpenValue: boolean;
  declare readonly removeOnCloseValue: boolean;

  private readonly beforeMorphHandler = this.beforeMorph.bind(this);

  connect() {
    if (this.autoOpenValue) {
      this.showModal();
    }

    this.element.addEventListener("turbo:before-morph-element", this.beforeMorphHandler);
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.beforeMorphHandler);
  }

  closeOutside(event: { target: HTMLDialogElement }) {
    if (event.target === this.element) {
      this.close();
    }
  }

  beforeMorph(event: Event) {
    if (this.element.open) {
      event.preventDefault();
    }
  }

  close() {
    this.element.close();
    if (this.removeOnCloseValue) {
      this.remove();
    }
  }

  private showModal() {
    if (!this.element.open) {
      this.element.showModal();
    }
  }

  private remove() {
    this.element.remove();
  }
}
